import React from 'react';
import { UnitConverter } from './UnitConverter';

const units = [
  { key: 'ftsec',  label: 'ft / sec' },
  { key: 'msec',   label: 'm / sec' },
  { key: 'cmsec',  label: 'cm / sec' },
  { key: 'milehr', label: 'miles / hr' },
  { key: 'kmhr',   label: 'km / hr' },
];

// Base: ft/sec
const factors = {
  ftsec:  1,
  msec:   1 / 3.281,
  cmsec:  30.48,
  milehr: 1 / 1.467,
  kmhr:   1.097,
};

export const ConvVelocity = () => (
  <UnitConverter
    title="Velocity"
    units={units}
    factors={factors}
    explanationTitle="Units of velocity"
    explanation="1 ft/sec = 0.3048 m/s; 1 mile/hr = 1.609 km/hr. The English system's 1 ft/sec is 0.3048 times a metre per second in the metric system."
  />
);
